import Vue from 'vue'
import App from './App'
// import './style/iconfont/iconfont.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import { Carousel, CarouselItem } from 'element-ui'

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App)
})
